import classNames from "classnames";
import { columnSticky } from "components/Leasing/constrant/leasing.ct";
import { Fragment, useState } from "react";
import FootageRowSubInfo from "./leasing.f.rowsubinfo";

const FootageRowInfo = ({
  loan,
  row,
  i,
  expanded,
  isHilight = false,
  isDisabled = false,
  isExpanded,
  isPlus,
  setHeaderTotal,
  headerTotal,
  columnPreInstallments = [],
}) => {
  return (
    <Fragment>
      <tr
        className={classNames(
          "transition-all duration-300 bg-green-100 z-50",
          { " border-blue-400 animate-pulse	": isHilight },
          {  "bg-gray-200": row.original.disabledPeriod,},
          
          // { "bg-gray-100": isDisabled && row.original.type === "CURRENT" },
          // { "bg-red-100": row.original.type === "LATE" },
          // { "bg-green-100": row.original.type === "OVERFLOW" }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={classNames("p-4 text-gray-700 text-xs text-center", {
                // [columnSticky]: cell.column.id === "period",
              })}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>

      {isExpanded
        ? row.original.pre_installments?.map(
            (pre_installment, pre_installment_index) => {
              return (
                <tr
                  // className={classNames({
                  //   "border-blue-400 animate-pulse	":
                  //     pre_installment.pre_status === "PENDING",
                  // })}
                  key={pre_installment_index}
                >
                  {columnPreInstallments.map((row, index) => {
                    return FootageRowSubInfo({
                      expanded,
                      render: row.render,
                      accessor: row.accessor,
                      index,
                      pre_installment,
                      pre_installment_index,
                      primaryIndex: i,
                      isPlus,
                      setHeaderTotal,
                      headerTotal,
                      loan,
                    });
                  })}
                </tr>
              );
            }
          )
        : null}
    </Fragment>
  );
};

export default FootageRowInfo;
